export type ScheduleFilterStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'OVERDUE';
export type ScheduleFilterType = 'SCHEDULED' | 'ADHOC';
export type ScheduleFilterScheduleType = 'single' | 'team';
export type ScheduleSortField = 'siteName' | 'status' | 'type';
export type ScheduleSortDirection = 'asc' | 'desc';

export interface ScheduleFilterState {
  sites: string[];
  statuses: ScheduleFilterStatus[];
  types: ScheduleFilterType[];
  scheduleTypes: ScheduleFilterScheduleType[];
  sortField: ScheduleSortField;
  sortDirection: ScheduleSortDirection;
}

export interface ScheduleApiFilterParams {
  sites?: string[];
  status?: string[];
  types?: string[];
  scheduleType?: string[];
}

export const DEFAULT_FILTER_STATE: ScheduleFilterState = {
  sites: [],
  statuses: [],
  types: [],
  scheduleTypes: [],
  sortField: 'siteName',
  sortDirection: 'asc'
};

export const isFilterActive = (filter: ScheduleFilterState): boolean =>
  filter.sites.length > 0 ||
  filter.statuses.length > 0 ||
  filter.types.length > 0 ||
  filter.scheduleTypes.length > 0;
